// wizard.js

export const INITIAL_STATE = {
  currentStep: 0,
  minStep: 0,
  maxStep: undefined,
  completedSteps: [],
  maxStepReached: 0,
};

// action types
const INCREMENT_STEP = "unido-web/wizard/INCREMENT_STEP";
const DECREMENT_STEP = "unido-web/wizard/DECREMENT_STEP";
const UPDATE_STEP = "unido-web/wizard/UPDATE_STEP";
const INITIALIZE = "unido-web/wizard/INITIALIZE";
const SET_STEP_COMPLETED = "unido-web/wizard/SET_STEP_COMPLETED";
const SET_STEP_NOT_COMPLETED = "unido-web/wizard/SET_STEP_NOT_COMPLETED";
const SET_SPECIFIC_STEP_COMPLETED =
  "unido-web/wizard/SET_SPECIFIC_STEP_COMPLETED";

// reducer
const wizardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INCREMENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
        maxStepReached:
          state.maxStepReached < state.currentStep + 1
            ? state.currentStep + 1
            : state.maxStepReached,
      };
    case DECREMENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep - 1,
      };
    case UPDATE_STEP:
      return {
        ...state,
        currentStep: action.stepNumber,
      };
    case INITIALIZE:
      return {
        ...state,
        maxStep: action.numberOfSteps - 1,
        completedSteps: Array(action.numberOfSteps).fill(false),
        currentStep: 0,
        maxStepReached: 0,
      };
    case SET_STEP_COMPLETED:
      return {
        ...state,
        completedSteps: state.completedSteps.map(
          (step, index) => (index === state.currentStep ? true : step)
        ),
      };

    case SET_STEP_NOT_COMPLETED:
      return {
        ...state,
        completedSteps: state.completedSteps.map(
          (step, index) => (index === state.currentStep ? false : step)
        ),
      };

    case SET_SPECIFIC_STEP_COMPLETED:
      return {
        ...state,
        completedSteps: state.completedSteps.map(
          (step, index) => (index === action.stepNo ? true : step)
        ),
      };

    default:
      return state;
  }
};

export default wizardReducer;

// action creators
export const incrementStep = () => {
  return {
    type: INCREMENT_STEP,
  };
};

export const decrementStep = () => {
  return {
    type: DECREMENT_STEP,
  };
};

export const updateStep = stepNumber => {
  return {
    type: UPDATE_STEP,
    stepNumber,
  };
};

export const initializeWizard = numberOfSteps => {
  return {
    type: INITIALIZE,
    numberOfSteps,
  };
};

export const setStepCompleted = () => {
  return {
    type: SET_STEP_COMPLETED,
  };
};

export const setStepNotCompleted = () => {
  return {
    type: SET_STEP_NOT_COMPLETED,
  };
};

export const setSpecificStepCompleted = stepNo => {
  return {
    type: SET_SPECIFIC_STEP_COMPLETED,
    stepNo,
  };
};
